<template>
  <div :class="$style.wrapper">
    <v-help button="НАЧАТЬ" ref="startHelp" @click="stage = 1">
      Перед тобой одна из схем, которой пользуются мошенники, чтобы обманным путем вывести деньги с банковской карты. Расставь по порядку шаги в этой схеме, чтобы бабушка больше не попадалась на уловки мошенников.
    </v-help>

    <v-help button="ДАЛЕЕ" ref="successBox" @click="$emit('success')">
      Теперь ты знаешь, что мошенники могут притворяться кем угодно, например, сотрудниками банков или других компаний, поэтому никогда не сообщай свою конфиденциальную информацию незнакомым людям. Лучше сразу положить трубку и перезвонить в банк или организацию самостоятельно (номер телефона можно найти на обратной стороне карточки или на сайте), также можно использовать определитель номера. Не забудь рассказать своей бабушке про такую мошенническую схему!
    </v-help>

    <transition name="bounce">
      <h2 v-if="stage === 0">Помоги Скобцу объяснить бабушке, <br> как мошенники обманывают людей и крадут деньги, <br> чтобы она не попалась на их уловки.</h2>
      <h2 v-if="stage === 2">Молодец! Тебе удалось объяснить бабушке, <br> как мошенники обманывают людей.</h2>
    </transition>

    <dragging :data="data" :active="stage === 1" @success="success" />
  </div>
</template>
<script>
import dragging from './components/dragging'

import data from './data'

export default {
  name: 'trainer3',
  components: { dragging },
  data: () => ({
    stage: 0,
    data,
  }),
  methods: {
    success() {
      this.stage = 2
      this.$refs.successBox.open()
      this.$store.commit('SET_RESULT', 20)
    },
  },
  mounted() {
    setTimeout(() => {
      this.$store.commit('SET_HEX_COLOR', 'purpleGreen')
      this.$store.commit('SET_HEX_ROTATION')
    }, 500)
    setTimeout(() => this.$refs.startHelp.open(), 500)
  },
}
</script>
<style lang="scss" module src="./trainer3.scss"></style>
